define((require) => {
    "use strict";

    const SettingsView = require("ui/settings/SettingsView");
    const template  = require("ui/settings/psdImport/PSDImportView.tpl");
    const PSDImportConstants = require("ui/settings/psdImport/PSDImportConstants.js");
    const EditorWebFontController = require("editor/ui/experience/editor/EditorWebFontController");
    const CharacterPropertiesViewControllerHelpers  = require("editor/ui/experience/widgets/CharacterPropertiesViewControllerHelpers");

    return SettingsView.extend({
        template,

        templateHelpers() {
            return {
                psdImportBaseUrl: process.env.APP_CONFIG.psdImportBaseUrl
            };
        },

        ui: {
            iframe: ".psd-import-iframe"
        },

        initialize() {
            window.addEventListener("message", this._handleMessage.bind(this), false);

            if (EditorWebFontController.promise()) {
                this._handleFontCollection();
            } else {
                EditorWebFontController.start();
                this.listenTo(EditorWebFontController, "fontsLoaded", this._handleFontCollection);
            }
        },

        _handleFontCollection() {
            EditorWebFontController.promise().then((results) => {
                CharacterPropertiesViewControllerHelpers._fontCollection = results;
            });
        },

        _handleMessage(event) {
            const {data} = event;
            const {type, data: messageData} = data;
            switch (type) {
                case PSDImportConstants.INITIALISATION_MESSAGE_TYPE:
                    this._handleInitialisation();
                    break;
                case PSDImportConstants.FONT_QUERY_MESSAGE_TYPE:
                    this._handleFontQuery(messageData);
                    break;
                default:
                    break;
            }
        },

        _handleInitialisation() {
            const win = window.frames.psdImport;
            const {token} = JSON.parse(localStorage.getItem("zmags_login"));
            if (token) {
                win.postMessage({type: "token", token}, process.env.APP_CONFIG.psdImportBaseUrl);
            }
        },

        _handleFontQuery(query) {
            CharacterPropertiesViewControllerHelpers._fontSelectorQuery({
                term: query,
                callback: (fonts) => {
                    const fontFamilyOptions = fonts.results.map((provider) => ({
                        label: provider.text,
                        options: provider.children.map((fontProvider) => ({
                            label: fontProvider.text,
                            value: fontProvider.text,
                            fontDescriptor: fontProvider.fontDescriptor
                        }))
                    }));

                    const win = window.frames.psdImport;
                    // is forbidden to send reference data types via postMessage method
                    win.postMessage({type: "fonts", fonts: JSON.stringify(fontFamilyOptions)}, process.env.APP_CONFIG.psdImportBaseUrl);
                }
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/psdImport/PSDImportView.js